import { useLocation } from 'react-router-dom';

export const GetCurrentRoute = () => {
  const location = useLocation();
  return location.pathname.substring(1);
};

